/**
 * SunFire Med Supp quotes expect `m` / `f`. Callers pass a mix of those
 * codes and the profile values `male` / `female`.
 *
 * Mapping only `male` → `m` (and everything else → `f`) treats the ALEX
 * selector's `'m'` as female, so male users get the wrong premiums.
 */
export function toSunfireGender(gender: string | null | undefined): 'm' | 'f' {
  const normalized = gender?.trim().toLowerCase();
  if (normalized === 'male' || normalized === 'm') {
    return 'm';
  }
  return 'f';
}

export function toSunfireEnrollmentGender(
  gender: string | null | undefined
): 'M' | 'F' {
  return toSunfireGender(gender) === 'm' ? 'M' : 'F';
}

export function toMedicareApiGender(
  gender: string | null | undefined
): 'male' | 'female' {
  return toSunfireGender(gender) === 'm' ? 'male' : 'female';
}
